import { render, staticRenderFns } from "./NewExample.vue?vue&type=template&id=39d4c63c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./NewExample.vue?vue&type=script&lang=js&"
export * from "./NewExample.vue?vue&type=script&lang=js&"
import style0 from "./NewExample.vue?vue&type=style&index=0&id=39d4c63c&lang=scss&scoped=true&"
import style1 from "./NewExample.vue?vue&type=style&index=1&id=39d4c63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d4c63c",
  null
  
)

export default component.exports